import { motion } from "framer-motion";
import AssessmentCta, { BetaPill } from "./AssessmentCta";
import { SampleRadar } from "./assessment/charts";

const ease = [0.22, 1, 0.36, 1];

/* Mid-page section on Home */
export const AssessmentPromoSection = () => (
  <section data-testid="assessment-promo" className="relative z-10 mx-auto w-full max-w-4xl px-6 py-24 text-center">
    <motion.div
      initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8, ease }}
      className="rounded-3xl border border-cyan-300/15 bg-gradient-to-br from-cyan-400/8 via-surface to-violet-400/8 p-10 sm:p-14"
    >
      <div className="mx-auto mb-6 flex justify-center"><SampleRadar /></div>
      <p className="flex items-center justify-center gap-2 font-mono text-sm uppercase tracking-[0.3em] text-cyan-300">
        Free Level 0 Assessment <BetaPill />
      </p>
      <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl">
        Let's check your current <span className="text-gradient">Lifespan Markers</span>
      </h2>
      <p className="mx-auto mt-4 max-w-xl text-lg font-light leading-relaxed text-fog">
        Body, mind and longevity signals, read in 4-5 minutes. Free.
      </p>
      <div className="mt-8 flex justify-center">
        <AssessmentCta src="mid" testId="promo-assessment-cta" />
      </div>
      <p className="mt-4 text-xs text-white/40">Free | 4-5 min | No login | Private</p>
    </motion.div>
  </section>
);

/* Repeat CTA block above the footer */
export const AssessmentPreFooter = () => (
  <section data-testid="assessment-prefooter" className="relative z-10 mx-auto w-full max-w-3xl px-6 pb-20 text-center">
    <motion.div
      initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, ease }}
    >
      <h3 className="font-display text-2xl font-bold sm:text-3xl">Curious where you stand today?</h3>
      <p className="mt-3 text-base font-light text-fog">Your Lifespan Markers in one free Level 0 snapshot.</p>
      <div className="mt-6 flex justify-center">
        <AssessmentCta src="prefooter" variant="accent" testId="prefooter-assessment-cta" />
      </div>
    </motion.div>
  </section>
);
